import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { getLatestPosts } from "../lib/api";
import { format } from "date-fns";

export default function HomePage() {
  const { data: posts, isLoading } = useQuery({
    queryKey: ["posts", "latest"],
    queryFn: () => getLatestPosts(),
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600" />
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h1 className="text-4xl font-bold tracking-tight sm:text-6xl">
          Welcome to AI Code Review
        </h1>
        <p className="mt-6 text-lg leading-8 text-gray-600">
          Work Hard. Have Fun. Make History.
        </p>
      </div>

      <div className="space-y-8">
        <h2 className="text-2xl font-bold tracking-tight">Latest Posts</h2>
        {posts?.map((post) => (
          <article
            key={post._id}
            className="flex flex-col items-start justify-between"
          >
            <div className="flex items-center gap-x-4 text-xs">
              <time dateTime={post.createdAt} className="text-gray-500">
                {format(new Date(post.createdAt), "MMM d, yyyy")}
              </time>
            </div>
            <div className="group relative">
              <h3 className="mt-3 text-lg font-semibold leading-6 group-hover:text-gray-600">
                <Link to={`/app/posts/${post._id}`} className="">
                  {post.title}
                </Link>
              </h3>
              <div className="mt-2 flex items-center space-x-4 text-sm">
                <div className="flex items-center gap-x-2">
                  <span className="">By {post.authorEmail}</span>
                </div>
              </div>
              <p className="mt-4 line-clamp-3">{post.body}</p>
            </div>
            <div className="mt-4 flex items-center gap-x-4">
              <Link
                to={`/app/posts/${post._id}`}
                className="text-quantum-iris hover:text-quantum-iris-dark"
              >
                Read post
              </Link>
              <Link to={`/app/posts/${post._id}`} className="text-sm">
                {post.comments.length} comments
              </Link>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link to="/app/posts" className="btn btn-primary">
          View all posts
        </Link>
      </div>
    </div>
  );
}
